export default __webpack_public_path__ + "static/media/738.8831eea8.png";